import { Link, Section } from '@cmg/design-system';
import { useMemo } from 'react';

import { OfferingDetails_PublishedOffering_ProspectusDocumentFragment } from '../../offering-side-panel/offering-details/graphql/__generated__';
import { KeyValuePair } from './KeyValuePair';

type DocumentationSectionProps = {
  prospectusDocuments: Readonly<OfferingDetails_PublishedOffering_ProspectusDocumentFragment[]>;
};

export function DocumentationSection({ prospectusDocuments }: Readonly<DocumentationSectionProps>) {
  const publishedProspectus = useMemo(() => {
    return prospectusDocuments?.filter(doc => doc.publicUrl && doc.publicUrl.trim()) ?? [];
  }, [prospectusDocuments]);

  if (publishedProspectus.length < 1) {
    return null;
  }
  return (
    <Section title="Documentation">
      <KeyValuePair
        label="Document(s)"
        value={
          <span>
            {publishedProspectus.map((doc, index) => [
              index > 0 && ', ',
              <Link key={index} href={doc.publicUrl!} target="_blank" rel="noopener noreferrer">
                {doc.documentName}
              </Link>,
            ])}
          </span>
        }
      />
    </Section>
  );
}
